var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "norway",
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_157",
    "data-name": "Ellipse 157",
    cx: 14.994,
    cy: 15,
    rx: 14.994,
    ry: 15,
    transform: "translate(-0.001 0)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_283",
    "data-name": "Group 283",
    transform: "translate(0.607 0.022)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2337",
    "data-name": "Path 2337",
    d: "M8.819,322.783a14.972,14.972,0,0,0,5.336,7.966v-7.966Z",
    transform: "translate(-8.819 -303.921)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2338",
    "data-name": "Path 2338",
    d: "M233.739,333.783c.429.037.862.057,1.3.057a14.96,14.96,0,0,0,14.438-11.057H233.739Z",
    transform: "translate(-220.601 -303.921)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2339",
    "data-name": "Path 2339",
    d: "M249.478,11.057A14.96,14.96,0,0,0,235.039,0c-.438,0-.872.02-1.3.057v11Z",
    transform: "translate(-220.601)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2340",
    "data-name": "Path 2340",
    d: "M14.155,52.9a14.972,14.972,0,0,0-5.336,7.966h5.336Z",
    transform: "translate(-8.819 -49.804)",
    fill: "#d80027"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2341",
    "data-name": "Path 2341",
    d: "M29.78,18.738H11.7V6.085A14.848,14.848,0,0,0,7.8,7.548V18.737H.127a15.1,15.1,0,0,0,0,3.9H7.8V33.829a14.848,14.848,0,0,0,3.9,1.463V22.64H29.78a15.1,15.1,0,0,0,0-3.9Z",
    transform: "translate(0.092 -5.707)",
    fill: "#0052b4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNo);
export default __webpack_public_path__ + "static/media/NO.4ef5966d00389c5b48718a6d598e8512.svg";
export { ForwardRef as ReactComponent };